import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import Creatable from "react-select/creatable";
import FormField from "../FormField";

interface Props {
    supportOfSale: Record<string, any>;
    supportOfSales: any[];
    isEditMode: boolean;
    isConsult: boolean;
    inputSupportOfSale: boolean;
    isNameExist: boolean;
    onChange: (e: any) => void;
}

const isValidNewOptionFalse = () => false;

const SupportOfSaleField = React.memo(
    ({
        supportOfSale,
        supportOfSales,
        isEditMode,
        isConsult,
        inputSupportOfSale,
        isNameExist,
        onChange,
    }: Props) => {
        const { t } = useTranslation();

        const value = useMemo(
            () =>
                !supportOfSale || Object.keys(supportOfSale).length === 0
                    ? null
                    : {
                          label: supportOfSale.label,
                          value: supportOfSale.value,
                      },
            [supportOfSale]
        );

        return (
            <FormField
                label={t("Support of sale")}
                required
                disabled={isConsult}
                error={inputSupportOfSale}
                errorMessage={t("Please select a support of sale")}
                secondError={isNameExist}
                secondErrorMessage={t(
                    "The combination mode of information , support of sale already exists"
                )}
            >
                <Creatable
                    isClearable
                    maxMenuHeight={150}
                    isValidNewOption={isValidNewOptionFalse}
                    options={supportOfSales}
                    onChange={onChange}
                    value={value}
                    className={classnames("mdi_inp_FRsalesSupport", {
                        invalid__clz: inputSupportOfSale || isNameExist,
                        "not-allowed-input__clz": isEditMode,
                    })}
                    name="supportOfSale"
                    placeholder={`${t("Select")}...`}
                />
            </FormField>
        );
    }
);

SupportOfSaleField.displayName = "SupportOfSaleField";
export default SupportOfSaleField;
